module.exports = __webpack_public_path__ + "img/comprobar.e10304db.svg";